module.exports = __webpack_public_path__ + "static/media/aicpa-cima-logo-mobile.4d9870b9.svg";